import {view} from '@sail/ui';
import {ChatRow} from './ChatRow';
import {TextBubble} from './TextBubble';
import {TextBody} from './TextBody';
import {TextBubbleDotCom} from './TextBubbleDotCom';

export type Props = {
  body: string;
  position?: 'start' | 'end';
  style?: 'bubble' | 'info' | 'none';
  avatar?: React.ReactNode | null | undefined;
  messageType?: React.ComponentProps<typeof TextBubble>['messageType'];
  background?: 'neutral100' | 'neutral600';
  error?: React.ReactNode;
  children?: React.ReactNode;
  useDotComDesign?: boolean;
  messageId?: string;
  isOwnMessage?: boolean;
};

export const TextRow = ({
  body,
  style = 'bubble',
  position,
  avatar,
  messageType = 'user',
  background = 'neutral100',
  error,
  children,
  useDotComDesign = false,
  messageId,
  isOwnMessage,
}: Props) => {
  let component;

  switch (style) {
    case 'bubble': {
      if (useDotComDesign && !isOwnMessage) {
        component = (
          <TextBubbleDotCom
            messageId={messageId}
            body={body}
            background={background}
            messageType={messageType}
          >
            {children}
          </TextBubbleDotCom>
        );
        break;
      }

      component = (
        <TextBubble
          body={body}
          background={background}
          messageType={messageType}
        >
          {children}
        </TextBubble>
      );
      break;
    }
    case 'info':
      component = (
        <view.span>
          <TextBody body={body} background={background} textSize="small" />
          {children}
        </view.span>
      );
      break;
    case 'none':
    default:
      component = (
        <>
          <TextBody body={body} background={background} />
          {children}
        </>
      );
  }

  return (
    <view.div data-testid="text-row">
      <ChatRow
        avatar={avatar}
        position={position}
        error={error}
        messageType={messageType}
      >
        {component}
      </ChatRow>
    </view.div>
  );
};
